/* eslint-disable camelcase */
import PropTypes from 'prop-types';

import {
  propTypesAltLanguage,
  propTypesFAQContent,
  propTypesIllustration,
  propTypesReviews,
  propTypesTextHtml,
} from '../../shared/constants/Proptypes';
import { propTypesCategory } from '../Category/Category.proptypes';
import { propTypesTag } from '../Tag/Tag.proptypes';

export const propTypesAuthor = {
  data: PropTypes.shape({
    description: PropTypes.shape(propTypesTextHtml),
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    profile_picture: PropTypes.shape(propTypesIllustration),
  }),
  id: PropTypes.string,
};

export const propTypesPost = {
  alternate_languages: PropTypes.shape(propTypesAltLanguage),
  data: PropTypes.shape({
    author: PropTypes.shape({
      document: PropTypes.shape(propTypesAuthor),
    }),
    body: PropTypes.shape({}),
    breadcrumb_title: PropTypes.string,
    category: PropTypes.shape({
      document: PropTypes.shape(propTypesCategory),
    }),
    faq_content: PropTypes.shape(propTypesFAQContent),
    illustration: PropTypes.shape(propTypesIllustration),
    is_shareable: PropTypes.bool,
    lede: PropTypes.string,
    meta_description: PropTypes.string,
    meta_title: PropTypes.string,
    og_description: PropTypes.string,
    publication_date: PropTypes.string,
    reading_time: PropTypes.number,
    reviews: PropTypes.shape(propTypesReviews),
    tag_1: PropTypes.shape({
      document: PropTypes.shape(propTypesTag),
    }),
    tag_2: PropTypes.shape({
      document: PropTypes.shape(propTypesTag),
    }),
    tag_3: PropTypes.shape({
      document: PropTypes.shape(propTypesTag),
    }),
    title: PropTypes.shape(propTypesTextHtml),
  }),
  first_publication_date: PropTypes.string,
  lang: PropTypes.string,
  last_publication_date: PropTypes.string,
  type: PropTypes.string,
  uid: PropTypes.string,
  url: PropTypes.string,
};
